import React, { useState } from "react"
import StaticSelector from "components/Atoms/StaticSelector"
import StringInput from "components/Atoms/StringInput"
import ButtonMutation from "components/Molecules/ButtonMutation"
import DynamicSelector from "components/Molecules/DynamicSelector"
import FormController from "components/Molecules/FormController"
import AppToaster from "utils/AppToaster"
import { BOURNE_BY } from "data/static.items"
import { EXPENSE_TYPES } from "graphql/selector.queries.gql"
import { ADD_VEHICLE_EXPENSE } from "graphql/vehicle-management/vehicle-management.mutations.gql"
import { CONTRACT_EXPENSES } from "graphql/vehicle-management/vehicle-management.queries.gql"
import { getErrors } from "hooks/useErrors"
import expenseModel from "models/expense.model"
import ExpenseRecords from "./expense/ExpenseRecords"

const VehicleExpense = ({ vehicle }) => {
  const [expense, setExpense] = useState({
    netAmount: 0,
    resourceUsed: 0,
    borneBy: BOURNE_BY[0],
    expenseTypeId: null,
    quantity: 0,
    quantityRate: 0,
    remark: "",
  })

  function handleChange(path, value) {
    switch (path) {
      case "quantity":
        setExpense(prev => ({
          ...prev,
          [path]: value,
          netAmount: value * prev.quantityRate,
        }))
        return
      case "quantityRate":
        setExpense(prev => ({
          ...prev,
          [path]: value,
          netAmount: value * prev.quantity,
        }))
        return
      default:
        setExpense(prev => ({
          ...prev,
          [path]: value,
        }))
        return
    }
  }
  return (
    <div className="vt-vehicle-payments">
      <FormController source={expense} onChange={handleChange}>
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-3">
            <DynamicSelector
              required
              query={EXPENSE_TYPES}
              path="expenseTypeId"
              label="Expense Type"
              helperText="eg. Fuel, Driver..etc"
            />
          </div>
          <div className="col-span-3">
            <StringInput
              required
              big={false}
              label="Quantity"
              path="quantity"
              helperText={
                <span className="text-muted">amount filled in Lt.</span>
              }
            />
          </div>
          <div className="col-span-3">
            <StringInput
              required
              big={false}
              label="Quantity Rate"
              path="quantityRate"
              helperText={<span className="text-muted">(₹) per unit</span>}
            />
          </div>
          <div className="col-span-3">
            <StringInput
              required
              helperText="Net Amount"
              path="netAmount"
              big={false}
              label="Net Amount"
              labelInfo={<span className="text-muted">(Units)</span>}
            />
          </div>
        </div>
        <div className="grid grid-cols-12 gap-4 mt-3">
          <div className="col-span-3">
            <StaticSelector
              required
              items={BOURNE_BY}
              path="borneBy"
              label="Bourne By"
            />
          </div>
          <div className="col-span-3">
            <StringInput
              label="Resource Used"
              path="resourceUsed"
              big={false}
              helperText="eg. Odometer Rating"
              labelInfo={<span className="text-muted">(Units)</span>}
            />
          </div>
          <div className="col-span-6">
            <StringInput big={false} path="remark" label="Remark" />
          </div>
        </div>
      </FormController>

      <div className="flex flex-col items-end justify-end mb-3">
        <ButtonMutation
          onCompleted={data => {
            AppToaster.show({
              message: `${expense?.expenseTypeId?.name} for ${vehicle?.registrationNumber} added successfully`,
              intent: "success",
              icon: "tick",
            })
          }}
          validate={state => {
            const errors = getErrors({
              schema: expenseModel,
              state,
              abortEarly: true,
            })

            if (errors.latest) {
              AppToaster.show({
                message: errors.latest,
                intent: "danger",
                icon: "cross",
              })
              return false
            }
            return true
          }}
          icon="confirm"
          text="Add Expense"
          refetchQueries={[
            {
              query: CONTRACT_EXPENSES,
              variables: { contractId: vehicle?.currentContract?.id },
            },
          ]}
          variables={{
            ...expense,
            expenseTypeId: expense?.expenseTypeId?.id,
            borneBy: expense?.borneBy?.id,
            contractId: vehicle?.currentContract?.id,
            expenseFor: vehicle?.id,

            name: `${expense?.expenseTypeId?.name} for ${vehicle?.registrationNumber}`,
          }}
          mutation={ADD_VEHICLE_EXPENSE}
          onError={err => {
            AppToaster.show({
              message: "Unable to add expense",
              intent: "danger",
              icon: "cross",
            })
          }}
        />
        <br></br>
      </div>
      <ExpenseRecords contractId={vehicle?.currentContract?.id} />
    </div>
  )
}

export default VehicleExpense
